import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import './MobileBottomSheet.css';

// Heights in dvh — CSS max-height caps the panel so it never overflows the island margins
const SNAPS = [0.36, 0.62, 0.82];

export default function MobileBottomSheet({ isOpen, onClose, children, initialSnap = 1, variant = 'default' }) {
  const [mounted, setMounted] = useState(isOpen);
  const [snapIdx, setSnapIdx] = useState(initialSnap);
  const panelRef = useRef(null);
  const dragStartY = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setMounted(true);
      setSnapIdx(initialSnap);
    } else {
      const t = setTimeout(() => setMounted(false), 320);
      return () => clearTimeout(t);
    }
  }, [isOpen, initialSnap]);

  const handleTouchStart = (e) => {
    dragStartY.current = e.touches[0].clientY;
    if (panelRef.current) panelRef.current.style.transition = 'none';
  };

  const handleTouchMove = (e) => {
    if (dragStartY.current === null) return;
    const dy = e.touches[0].clientY - dragStartY.current;
    if (dy > 0 && panelRef.current) {
      panelRef.current.style.transform = `translateY(${dy}px)`;
    }
  };

  const handleTouchEnd = (e) => {
    if (dragStartY.current === null) return;
    const dy = e.changedTouches[0].clientY - dragStartY.current;
    dragStartY.current = null;
    const panel = panelRef.current;
    if (panel) {
      panel.style.transition = '';
      if (dy <= 0) panel.style.transform = '';
    }

    if (dy > 120) {
      if (snapIdx === 0) { onClose(); }
      else setSnapIdx(s => s - 1);
    } else if (dy > 60 && snapIdx === 0) {
      onClose();
    } else if (dy < -60 && snapIdx < SNAPS.length - 1) {
      setSnapIdx(s => s + 1);
    } else {
      if (panel) panel.style.transform = '';
    }
  };

  if (!mounted) return null;

  return ReactDOM.createPortal(
    <div className={`bottom-sheet-root${isOpen ? ' is-open' : ''}`}>
      <div className="bottom-sheet-backdrop" onClick={onClose} />
      <div
        ref={panelRef}
        className={`bottom-sheet-panel bottom-sheet-panel--${variant}`}
        style={{ height: `${SNAPS[snapIdx] * 100}dvh` }}
      >
        <div
          className="bottom-sheet-handle-bar"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        />
        <div className="bottom-sheet-body">
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}
